/** Select the truthful attachment and metadata artifacts for one Kuali module. */
import { FileText } from 'lucide-react'

import { Checkbox } from '@/components/ui'
import type { KualiResearchModuleOptions } from '../types'
import { KualiResearchAttachmentTypeSelection } from './KualiResearchAttachmentTypeSelection'
import { KUALI_RESEARCH_SOURCES } from './KualiResearchSourceSelection'

export function KualiResearchModuleDocuments({
  module,
  onChange,
}: {
  module: KualiResearchModuleOptions
  onChange: (module: KualiResearchModuleOptions) => void
}) {
  const definition = KUALI_RESEARCH_SOURCES.find(value => value.value === module.source)
  return (
    <fieldset className="space-y-2">
      <legend className="text-[12px] font-semibold text-slate-700">
        {definition?.label} documents <span className="font-normal text-slate-400">— applies to both modes</span>
      </legend>
      {module.source === 'awards' && (
        <div className="space-y-1.5 rounded-[9px] border border-slate-200 p-3">
          <p className="text-[11.5px] text-slate-500">
            <strong className="font-semibold text-slate-700">Award attachments</strong><br />{definition?.documents}
          </p>
          <KualiResearchAttachmentTypeSelection
            selectedCodes={module.attachmentTypeCodes}
            onSelectedCodesChange={attachmentTypeCodes => onChange({ ...module, attachmentTypeCodes })}
          />
        </div>
      )}
      {module.source !== 'awards' && (
        <div className="flex items-start gap-2 rounded-[9px] border border-slate-200 bg-slate-50 px-3 py-2.5 text-[11.5px] text-slate-600">
          <FileText className="mt-px h-3.5 w-3.5 shrink-0 text-slate-500" />
          <span><strong className="font-semibold text-slate-700">Award attachments</strong><br />{definition?.documents}</span>
        </div>
      )}
      <label className="flex cursor-pointer items-start gap-2 rounded-[9px] border border-slate-200 px-3 py-2.5 text-[11.5px] text-slate-600">
        <Checkbox
          aria-label="Include award metadata"
          checked={module.includeMetadata}
          onCheckedChange={checked => onChange({ ...module, includeMetadata: checked === true })}
          className="mt-px"
        />
        <span>
          <strong className="font-semibold text-slate-700">Include award metadata</strong>
          <span className="mt-0.5 block">{definition?.metadata} Saved as a separate JSON text document.</span>
        </span>
      </label>
      {module.source === 'negotiations' && (
        <label className="flex cursor-pointer items-start gap-2 rounded-[9px] border border-amber-200 bg-amber-50 px-3 py-2 text-[11.5px] text-amber-800">
          <Checkbox
            aria-label="Include restricted Negotiation content"
            checked={module.includeRestrictedAttachments}
            onCheckedChange={checked => onChange({ ...module, includeRestrictedAttachments: checked === true })}
          />
          <span><strong className="font-semibold">Include restricted Negotiation content</strong><br />Includes restricted attachments and restricted fields in the metadata document. Use only in an authorized workspace.</span>
        </label>
      )}
    </fieldset>
  )
}
